var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse",attrs:{"tabindex":"0","role":"button"},on:{"click":_vm.toggleCollapse}},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.materialIcon))]),(_vm.showBadge)?_c('div',{staticClass:"badge",class:_vm.materialIcon},[_vm._v(" "+_vm._s(_vm.countBadge)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }